import { getYear, parseISO } from "date-fns";

import { CompletedListJobsAnswer } from "~/common/utils";

interface PastJobsAnswerProps {
  answers: CompletedListJobsAnswer[];
}

export const PastJobsAnswer = ({ answers }: PastJobsAnswerProps) => {
  return answers[0].jobs_you_have_held.map(
    (
      {
        place_of_employment,
        job_title,
        date_started,
        date_ended,
        why_did_you_leave,
      },
      index,
    ) => {
      const yearStarted = getYear(parseISO(date_started));
      const yearEnded = getYear(parseISO(date_ended));
      return (
        <p key={index} className="mb-4 last:mb-0">
          {[
            place_of_employment,
            job_title,
            `${yearStarted}-${yearEnded}`,
            why_did_you_leave,
          ].join(", ")}
        </p>
      );
    },
  );
};
